import React, { useState, useEffect } from "react";
import logo from "../../assets/img/login1.png";
import axios from "axios";
import { baseurl } from "../../baseurl";
import Swal from "sweetalert2";

/* ── all class names prefixed with "bi__" ── */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700;800&family=Inter:wght@400;500;600&display=swap');

@keyframes bi__spin   { to { transform: rotate(360deg); } }
@keyframes bi__floatA { 0%,100% { transform: translateY(0px) scale(1); }   50% { transform: translateY(-18px) scale(1.04); } }
@keyframes bi__floatB { 0%,100% { transform: translateY(0px) scale(1); }   50% { transform: translateY(14px) scale(0.97); } }
@keyframes bi__floatC { 0%,100% { transform: translate(0,0); }             50% { transform: translate(10px,-12px); } }
@keyframes bi__fadeUp { from { opacity:0; transform:translateY(28px); } to { opacity:1; transform:translateY(0); } }
@keyframes bi__pulse  { 0%,100% { box-shadow: 0 0 0 0 rgba(10,85,86,0.4); } 70% { box-shadow: 0 0 0 9px rgba(10,85,86,0); } }
@keyframes bi__shimmer { 0% { background-position:-400px 0; } 100% { background-position:400px 0; } }

*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

.bi__root {
  min-height: 100vh;
  display: flex;
  font-family: 'Inter', 'Segoe UI', sans-serif;
  background: #eef6f6;
  position: relative;
  overflow-x: hidden;
}

/* ── blobs ── */
.bi__blob { position: fixed; border-radius: 50%; pointer-events: none; }
.bi__blob--1 {
  width: 500px; height: 500px; top: -170px; left: -170px;
  background: radial-gradient(circle, rgba(10,85,86,0.18) 0%, transparent 68%);
  animation: bi__floatA 8s ease-in-out infinite;
}
.bi__blob--2 {
  width: 440px; height: 440px; bottom: -130px; right: -110px;
  background: radial-gradient(circle, rgba(20,184,166,0.15) 0%, transparent 68%);
  animation: bi__floatB 10s ease-in-out infinite;
}
.bi__blob--3 {
  width: 300px; height: 300px; top: 38%; left: 40%;
  background: radial-gradient(circle, rgba(10,85,86,0.08) 0%, transparent 70%);
  animation: bi__floatC 12s ease-in-out infinite;
}
.bi__blob--4 {
  width: 200px; height: 200px; top: 8%; right: 28%;
  background: radial-gradient(circle, rgba(255,209,102,0.18) 0%, transparent 70%);
  animation: bi__floatB 9s ease-in-out infinite;
}
.bi__grid {
  position: fixed; inset: 0; pointer-events: none;
  background-image:
    linear-gradient(rgba(10,85,86,0.04) 1px, transparent 1px),
    linear-gradient(90deg, rgba(10,85,86,0.04) 1px, transparent 1px);
  background-size: 52px 52px;
}

/* ── LEFT PANEL ── */
.bi__panel {
  flex: 0.9;
  display: flex; flex-direction: column;
  justify-content: center; align-items: flex-start;
  padding: 72px 52px; gap: 24px;
  position: relative; z-index: 1;
}
.bi__panel-badge {
  display: inline-flex; align-items: center; gap: 8px;
  background: rgba(10,85,86,0.08); border: 1px solid rgba(10,85,86,0.22);
  border-radius: 50px; padding: 8px 18px;
  font-family: 'Sora', sans-serif; font-size: 11.5px; font-weight: 700;
  color: #0a5556; letter-spacing: 0.08em; text-transform: uppercase;
  animation: bi__fadeUp 0.6s ease both;
}
.bi__panel-dot {
  width: 7px; height: 7px; border-radius: 50%;
  background: #0a5556; animation: bi__pulse 2s infinite;
}
.bi__panel-heading {
  font-family: 'Sora', sans-serif;
  font-size: clamp(26px, 3.2vw, 42px);
  font-weight: 800; color: #062020;
  line-height: 1.2; letter-spacing: -0.04em; max-width: 380px;
  animation: bi__fadeUp 0.65s 0.1s ease both;
}
.bi__panel-accent {
  color: #0a5556; position: relative; display: inline-block;
}
.bi__panel-accent::after {
  content: ''; position: absolute; bottom: 1px; left: 0;
  width: 100%; height: 3px;
  background: linear-gradient(90deg, #0a5556, #14b8a6);
  border-radius: 2px;
}
.bi__panel-sub {
  font-size: 14.5px; color: #3d6060; max-width: 320px;
  line-height: 1.78; animation: bi__fadeUp 0.65s 0.18s ease both;
}

/* field overview tiles */
.bi__tiles {
  display: flex; flex-direction: column; gap: 10px;
  animation: bi__fadeUp 0.65s 0.26s ease both;
}
.bi__tile {
  display: flex; align-items: center; gap: 14px;
  background: rgba(255,255,255,0.74); backdrop-filter: blur(14px);
  border: 1px solid rgba(10,85,86,0.13);
  border-radius: 14px; padding: 12px 18px;
  box-shadow: 0 2px 14px rgba(10,85,86,0.07);
  transition: transform 0.22s, box-shadow 0.22s; cursor: default;
}
.bi__tile:hover { transform: translateX(7px); box-shadow: 0 6px 26px rgba(10,85,86,0.14); }
.bi__tile-icon {
  width: 36px; height: 36px; border-radius: 10px; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center; font-size: 16px;
  background: linear-gradient(135deg, #0a5556 0%, #14b8a6 100%);
  box-shadow: 0 4px 12px rgba(10,85,86,0.28);
}
.bi__tile-label { font-size: 13.5px; font-weight: 600; color: #132b2b; }

/* ── MAIN CONTENT ── */
.bi__main {
  flex: 1.3; display: flex; align-items: flex-start;
  justify-content: center; padding: 48px 36px;
  position: relative; z-index: 1; overflow-y: auto;
}

/* ── CARD ── */
.bi__card {
  width: 100%; max-width: 640px;
  background: rgba(255,255,255,0.91); backdrop-filter: blur(30px);
  border-radius: 30px;
  border: 1px solid rgba(255,255,255,0.88);
  box-shadow:
    0 0 0 1px rgba(10,85,86,0.06),
    0 8px 32px rgba(10,85,86,0.08),
    0 32px 80px rgba(0,0,0,0.09),
    inset 0 1px 0 #fff;
  animation: bi__fadeUp 0.75s 0.15s ease both;
  position: relative; overflow: hidden;
}
.bi__card::before {
  content: ''; position: absolute; top: 0; left: 0; right: 0; height: 4px;
  background: linear-gradient(90deg, #0a5556 0%, #14b8a6 55%, #FFD166 100%);
  border-radius: 30px 30px 0 0;
}

/* card header */
.bi__card-hd {
  display: flex; align-items: center; gap: 14px;
  padding: 30px 36px 22px;
}
.bi__card-hd-icon {
  width: 50px; height: 50px; border-radius: 16px; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center; font-size: 22px;
  background: linear-gradient(135deg, #0a5556, #14b8a6);
  box-shadow: 0 6px 20px rgba(10,85,86,0.30);
}
.bi__card-hd-logo {
  width: 50px; height: 50px; border-radius: 16px; overflow: hidden;
  border: 3px solid #fff;
  box-shadow: 0 4px 14px rgba(10,85,86,0.20);
  flex-shrink: 0;
}
.bi__card-hd-logo img { width: 100%; height: 100%; object-fit: cover; display: block; }
.bi__card-title { font-family: 'Sora', sans-serif; font-size: 20px; font-weight: 800; color: #062020; letter-spacing: -0.03em; margin: 0 0 3px; }
.bi__card-sub   { font-size: 12.5px; color: #6b8a8a; margin: 0; }

/* progress */
.bi__progress-bar {
  margin: 0 36px 22px;
  height: 5px; border-radius: 50px;
  background: #c8e4e4; overflow: hidden;
}
.bi__progress-fill {
  height: 100%; border-radius: 50px;
  background: linear-gradient(90deg, #0a5556, #14b8a6);
  width: 33%;
  transition: width 0.6s ease;
}
.bi__progress-label {
  font-size: 10.5px; font-weight: 700; color: #6b8a8a;
  margin: 0 36px 18px;
  letter-spacing: 0.06em; text-transform: uppercase;
}

/* section dividers inside card */
.bi__section {
  padding: 0 36px;
  margin-bottom: 22px;
}
.bi__section-title {
  display: flex; align-items: center; gap: 8px;
  font-family: 'Sora', sans-serif; font-size: 11px; font-weight: 700;
  color: #0a5556; text-transform: uppercase; letter-spacing: 0.1em;
  margin-bottom: 14px; padding-bottom: 8px;
  border-bottom: 1px solid rgba(10,85,86,0.09);
}
.bi__section-title-dot {
  width: 6px; height: 6px; border-radius: 50%;
  background: linear-gradient(135deg, #0a5556, #14b8a6);
}

/* label */
.bi__lbl {
  display: flex; align-items: center; gap: 6px;
  font-size: 11px; font-weight: 700; color: #132b2b;
  margin-bottom: 6px; letter-spacing: 0.06em; text-transform: uppercase;
}
.bi__lbl-dot { width: 5px; height: 5px; border-radius: 50%; background: #0a5556; }

/* input */
.bi__input {
  width: 100%; padding: 11px 15px;
  font-size: 13.5px; font-family: 'Inter', sans-serif; color: #0a2020;
  background: #f3fafa; border: 1.5px solid #c8e4e4; border-radius: 12px;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
  box-sizing: border-box;
}
.bi__input:focus { border-color: #0a5556; background: #fff; box-shadow: 0 0 0 4px rgba(10,85,86,0.10); }
.bi__input::placeholder { color: #9ababa; }
.bi__select {
  width: 100%; padding: 11px 15px;
  font-size: 13.5px; font-family: 'Inter', sans-serif; color: #0a2020;
  background: #f3fafa; border: 1.5px solid #c8e4e4; border-radius: 12px;
  outline: none; cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;
  box-sizing: border-box;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%235a8080' stroke-width='2.5'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
  background-repeat: no-repeat; background-position: right 14px center;
  padding-right: 36px;
}
.bi__select:focus { border-color: #0a5556; background-color: #fff; box-shadow: 0 0 0 4px rgba(10,85,86,0.10); }

.bi__field { margin-bottom: 14px; }
.bi__grid2 { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
.bi__grid3 { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 14px; }

/* card footer */
.bi__card-footer { padding: 6px 36px 30px; }
.bi__btn {
  width: 100%; padding: 14px;
  font-size: 15px; font-family: 'Sora', sans-serif; font-weight: 700;
  color: #fff; letter-spacing: 0.04em;
  background: linear-gradient(135deg, #0a5556 0%, #0c7172 50%, #14b8a6 100%);
  background-size: 200% auto;
  border: none; border-radius: 14px; cursor: pointer;
  box-shadow: 0 6px 26px rgba(10,85,86,0.36);
  transition: background-position 0.4s, transform 0.15s, box-shadow 0.2s;
  position: relative; overflow: hidden;
}
.bi__btn::after {
  content: ''; position: absolute; inset: 0;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.14), transparent);
  background-size: 400px 100%; opacity: 0; transition: opacity 0.3s;
}
.bi__btn:hover { background-position: right center; transform: translateY(-2px); box-shadow: 0 12px 34px rgba(10,85,86,0.44); }
.bi__btn:hover::after { opacity: 1; animation: bi__shimmer 1.1s linear infinite; }
.bi__btn:active { transform: translateY(0); }

.bi__skip { text-align: center; padding: 0 0 4px; font-size: 13px; color: #6b8a8a; }
.bi__skip a { font-weight: 700; color: #0a5556; text-decoration: none; }
.bi__skip a:hover { text-decoration: underline; }

/* optional tag */
.bi__opt {
  font-size: 9.5px; font-weight: 700; color: #9ababa;
  background: rgba(10,85,86,0.06); border: 1px solid #c8e4e4;
  border-radius: 50px; padding: 1px 7px; margin-left: 6px;
  text-transform: none; letter-spacing: 0;
}

/* ── RESPONSIVE ── */
@media (max-width: 960px) { .bi__panel { display: none !important; } .bi__main { padding: 32px 16px; } }
@media (max-width: 620px) {
  .bi__grid2, .bi__grid3 { grid-template-columns: 1fr; }
  .bi__card-hd, .bi__section, .bi__card-footer, .bi__progress-bar, .bi__progress-label { padding-left: 22px; padding-right: 22px; }
}
`;

function BusinessInfo() {
  const token = localStorage.getItem("auth_token");

  /* ── state (unchanged) ── */
  const [formData, setFormData] = useState({
    business_name: "",
    contact_email: "",
    whatsapp_number: "",
    employee_size: "",
    business_type: "",
    country: "",
    state: "",
    city: "",
    zipcode: "",
    gst: ""
  });

  /* ── fetch (unchanged) ── */
  useEffect(() => {
    if (!token) return;
    const fetchBusinessInfo = async () => {
      try {
        const res = await axios.get(`${baseurl}getBusinessInfo`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (res.data.success && res.data.data) {
          setFormData({
            business_name:   res.data.data.business_name   || "",
            contact_email:   res.data.data.contact_email   || "",
            whatsapp_number: res.data.data.whatsapp_number || "",
            employee_size:   res.data.data.employee_size   || "",
            business_type:   res.data.data.business_type   || "",
            country:         res.data.data.country         || "",
            state:           res.data.data.state           || "",
            city:            res.data.data.city            || "",
            zipcode:         res.data.data.zipcode         || "",
            gst:             res.data.data.gst             || ""
          });
        }
      } catch (error) {
        console.error("FETCH BUSINESS INFO ERROR:", error);
      }
    };
    fetchBusinessInfo();
  }, [token]);

  /* ── handlers (unchanged) ── */
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${baseurl}saveBusinessInfo`, formData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (res.data.success) {
        Swal.fire({
          toast: true, position: "top-end", icon: "success",
          title: res.data.message || "Business info updated",
          showConfirmButton: false, timer: 3000, timerProgressBar: true
        });
        setTimeout(() => { window.location.href = "/opt-features"; }, 1500);
      }
    } catch (error) {
      console.error("UPDATE BUSINESS INFO ERROR:", error);
      Swal.fire({
        toast: true, position: "top-end", icon: "error",
        title: error.response?.data?.message || "Failed to save business info",
        showConfirmButton: false, timer: 3000, timerProgressBar: true
      });
    }
  };

  /* ═══════════ RENDER ═══════════ */
  return (
    <>
      <style>{CSS}</style>

      <div className="bi__root">
        {/* blobs + grid */}
        <div className="bi__blob bi__blob--1" />
        <div className="bi__blob bi__blob--2" />
        <div className="bi__blob bi__blob--3" />
        <div className="bi__blob bi__blob--4" />
        <div className="bi__grid" />

        {/* ══ LEFT PANEL ══ */}
        <div className="bi__panel">
          <div className="bi__panel-badge">
            <div className="bi__panel-dot" />
            Step 2 of 3
          </div>

          <h1 className="bi__panel-heading">
            Tell us about<br />your
            <span className="bi__panel-accent"> business</span>
          </h1>

          <p className="bi__panel-sub">
            This helps us personalise your dashboard, generate
            GST-compliant invoices, and tailor reports to your business type.
          </p>

          <div className="bi__tiles">
            {[
              { icon: "🏢", label: "Business identity & contact" },
              { icon: "📍", label: "Location for GST compliance" },
              { icon: "👥", label: "Team size & business type" },
            ].map((t) => (
              <div className="bi__tile" key={t.label}>
                <div className="bi__tile-icon">{t.icon}</div>
                <span className="bi__tile-label">{t.label}</span>
              </div>
            ))}
          </div>
        </div>

        {/* ══ MAIN FORM ══ */}
        <div className="bi__main">
          <div className="bi__card">

            {/* Card Header */}
            <div className="bi__card-hd">
              <div className="bi__card-hd-logo">
                <img src={logo} alt="logo" />
              </div>
              <div>
                <div className="bi__card-title">Business Information</div>
                <div className="bi__card-sub">Tell us about your business to personalise your dashboard.</div>
              </div>
            </div>

            {/* Progress */}
            <div className="bi__progress-label">Setup progress — Step 2 of 3</div>
            <div className="bi__progress-bar">
              <div className="bi__progress-fill" />
            </div>

            <form onSubmit={handleSubmit}>

              {/* ── SECTION 1: Identity ── */}
              <div className="bi__section">
                <div className="bi__section-title">
                  <div className="bi__section-title-dot" /> Business Identity
                </div>
                <div className="bi__grid2">
                  <div className="bi__field">
                    <div className="bi__lbl"><div className="bi__lbl-dot" />Business Name</div>
                    <input type="text" name="business_name" className="bi__input"
                      placeholder="Acme Technologies Pvt Ltd"
                      value={formData.business_name} onChange={handleChange} required />
                  </div>
                  <div className="bi__field">
                    <div className="bi__lbl"><div className="bi__lbl-dot" />Contact Email</div>
                    <input type="email" name="contact_email" className="bi__input"
                      placeholder="contact@yourco.com"
                      value={formData.contact_email} onChange={handleChange} />
                  </div>
                </div>
                <div className="bi__grid2">
                  <div className="bi__field">
                    <div className="bi__lbl"><div className="bi__lbl-dot" />WhatsApp Number</div>
                    <input type="tel" name="whatsapp_number" className="bi__input"
                      placeholder="+91 98765 43210"
                      value={formData.whatsapp_number} onChange={handleChange} />
                  </div>
                  <div className="bi__field">
                    <div className="bi__lbl">
                      <div className="bi__lbl-dot" />GST Number
                      <span className="bi__opt">Optional</span>
                    </div>
                    <input type="text" name="gst" className="bi__input"
                      placeholder="22AAAAA0000A1Z5"
                      value={formData.gst} onChange={handleChange}
                      style={{ textTransform: "uppercase" }} />
                  </div>
                </div>
              </div>

              {/* ── SECTION 2: Classification ── */}
              <div className="bi__section">
                <div className="bi__section-title">
                  <div className="bi__section-title-dot" /> Classification
                </div>
                <div className="bi__grid2">
                  <div className="bi__field">
                    <div className="bi__lbl"><div className="bi__lbl-dot" />Business Type</div>
                    <select name="business_type" className="bi__select"
                      value={formData.business_type} onChange={handleChange}>
                      <option value="">Select type</option>
                      <option>Service</option>
                      <option>Product</option>
                      <option>Both</option>
                    </select>
                  </div>
                  <div className="bi__field">
                    <div className="bi__lbl"><div className="bi__lbl-dot" />Employee Size</div>
                    <select name="employee_size" className="bi__select"
                      value={formData.employee_size} onChange={handleChange}>
                      <option value="">Select size</option>
                      <option>1 - 10</option>
                      <option>11 - 50</option>
                      <option>51 - 100</option>
                      <option>100 - 250</option>
                      <option>250 - 500</option>
                      <option>500+</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* ── SECTION 3: Location ── */}
              <div className="bi__section">
                <div className="bi__section-title">
                  <div className="bi__section-title-dot" /> Location
                </div>
                <div className="bi__grid2">
                  <div className="bi__field">
                    <div className="bi__lbl"><div className="bi__lbl-dot" />Country</div>
                    <input type="text" name="country" className="bi__input"
                      placeholder="India"
                      value={formData.country} onChange={handleChange} />
                  </div>
                  <div className="bi__field">
                    <div className="bi__lbl"><div className="bi__lbl-dot" />State</div>
                    <input type="text" name="state" className="bi__input"
                      placeholder="Maharashtra"
                      value={formData.state} onChange={handleChange} />
                  </div>
                </div>
                <div className="bi__grid2">
                  <div className="bi__field">
                    <div className="bi__lbl"><div className="bi__lbl-dot" />City</div>
                    <input type="text" name="city" className="bi__input"
                      placeholder="Mumbai"
                      value={formData.city} onChange={handleChange} />
                  </div>
                  <div className="bi__field">
                    <div className="bi__lbl"><div className="bi__lbl-dot" />ZIP Code</div>
                    <input type="text" name="zipcode" className="bi__input"
                      placeholder="400001"
                      value={formData.zipcode} onChange={handleChange} />
                  </div>
                </div>
              </div>

              {/* Footer CTA */}
              <div className="bi__card-footer">
                <button type="submit" className="bi__btn">
                  Save &amp; Continue →
                </button>
              </div>

            </form>

            <div className="bi__skip" style={{ paddingBottom: 24 }}>
              Prefer to do it later?{" "}
              <a href="/dashboard">Skip for now</a>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}

export default BusinessInfo;
